const HIDDEN_NON_UPI_METHODS = [
  { method: 'netbanking' },
  { method: 'wallet' },
  { method: 'paylater' },
  { method: 'emi' },
];

const UPI_ONLY_CONFIG = {
  display: {
    blocks: {
      upiOnly: {
        name: 'Pay via UPI',
        instruments: [{ method: 'upi' }],
      },
    },
    hide: [{ method: 'card' }, ...HIDDEN_NON_UPI_METHODS],
    sequence: ['block.upiOnly'],
    preferences: { show_default_blocks: false },
  },
};

const TEST_MODE_CONFIG = {
  display: {
    blocks: {
      upiOnly: {
        name: 'Pay via UPI',
        instruments: [{ method: 'upi' }],
      },
      testCard: {
        name: 'Test Card (desktop)',
        instruments: [{ method: 'card', types: ['debit', 'credit'] }],
      },
    },
    hide: HIDDEN_NON_UPI_METHODS,
    sequence: ['block.upiOnly', 'block.testCard'],
    preferences: { show_default_blocks: false },
  },
};

export function buildRazorpayCheckoutOptions(baseOptions, { testMode = false } = {}) {
  return {
    ...baseOptions,
    config: testMode ? TEST_MODE_CONFIG : UPI_ONLY_CONFIG,
  };
}

export function isRazorpayTestKey(key) {
  return typeof key === 'string' && key.startsWith('rzp_test_');
}
